/** Generated from config/web-app-version at image build. */
export const WEB_APP_VERSION = "7";
